"use client";
/* eslint id-length: "off", no-magic-numbers: "off" */
import PropTypes from "prop-types";
import MagaImage from "@/components/gfx/MagaImage";

const SIZE_CLASS = {
  thumb: "mdmusic-artwork is-thumb",
  compact: "mdmusic-artwork is-compact",
  large: "mdmusic-artwork is-large",
};

// Natural pixel size handed to MagaImage so Next can request a sized source.
const SIZE_DIM = {
  thumb: 48,
  compact: 128,
  large: 220,
};

const zoomCaption = track => {
  if (!track.albumName) {
    return `${track.trackName} by ${track.artistName}`;
  }
  return (
    <p>
      <strong>{track.albumName}</strong>
      {track.releaseYear ? ` (${track.releaseYear})` : ""}{" "}
      <small>
        <i>
          <small>by</small>&nbsp;{track.artistName}
        </i>
      </small>
    </p>
  );
};

const MDMusicArtwork = ({size = "large", track}) => {
  const altText = track.albumName
    ? `${track.albumName} artwork`
    : `${track.trackName} artwork`;
  const figureClass = SIZE_CLASS[size] ?? SIZE_CLASS.large;
  const dim = SIZE_DIM[size] ?? SIZE_DIM.large;
  if (!track.artworkUrl) {
    return (
      <figure className={figureClass}>
        <div className="mdmusic-artwork-stub"/>
      </figure>
    );
  }
  return (
    <MagaImage alt={altText}
               caption={zoomCaption(track)}
               className={figureClass}
               dithered={false}
               fullSrc={track.artworkFullUrl ?? track.artworkUrl}
               height={dim}
               src={track.artworkUrl}
               width={dim}
               zoomable={size !== "thumb"}
    />
  );
};

MDMusicArtwork.propTypes = {
  size: PropTypes.oneOf(["thumb", "compact", "large"]),
  track: PropTypes.shape({
    artworkUrl: PropTypes.string,
    artworkFullUrl: PropTypes.string,
    albumName: PropTypes.string,
    artistName: PropTypes.string,
    releaseYear: PropTypes.number,
    trackName: PropTypes.string.isRequired,
  }).isRequired,
};

export default MDMusicArtwork;
